import {Grid} from '@yandex-delivery/blocks'
import {Image} from '@yandex-delivery/blocks/image'
import * as classes from './HeaderRu@mobile.classes'
import React from 'react'
import {tag2url} from '@yandex-delivery/utils'
import {FloatingBox, StickyTo} from '@yandex-delivery/form/ui/OrderForm/components/FloatingBox'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export function Header(): React.ReactElement {
  return (
    <FloatingBox height={spacing(9)} stickyTo={StickyTo.BLOCK_START} className={classes.box}>
      <header className={classes.header}>
        <Grid alignItems="center" direction="column" justify="flex-end" wrap="nowrap">
          <Grid direction="row" justify="space-between" alignItems="center" className={classes.mainLine}>
            <a href="/" className={classes.link}>
              <Image alt="Яндекс Доставка" height={25} srcSet={tag2url('delivery_landing_logo')} width="auto" />
            </a>
          </Grid>
        </Grid>
      </header>
    </FloatingBox>
  )
}
